import { render, staticRenderFns } from "./vehicle-infos.vue?vue&type=template&id=7c53fdac&scoped=true"
import script from "./vehicle-infos.vue?vue&type=script&lang=js"
export * from "./vehicle-infos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c53fdac",
  null
  
)

export default component.exports